// Components
import { BaseTable, Loading, PermissionLink } from "components"

// Icons
import { IoSendSharp } from "react-icons/io5"

// Types
import type { TableSectionProps } from "pages/Purchase/Register/types/AgedPayable"

// Utils
import { convertNumber } from "utils"
import { convertDate } from "pages/Inventori/Transaction/TransactionJournal/utils"
import { PERMISION } from "security"

export const TableSection = ({ data, isLoading }: TableSectionProps) => {
  return (
    <div className="overflow-auto max-h-[calc(100vh-570px)]">
      <BaseTable className="border-transparent">
        <thead className="top-0 z-1 !bg-black !text-white">
          <tr className="uppercase">
            <th>No</th>
            <th colSpan={2}>Bill Id#</th>
            <th>Ref Po Id#</th>
            <th>Delivery Date</th>
            <th>Vendor</th>
            <th>Total</th>
            <th>
              7<br />
              Days
            </th>
            <th>
              15
              <br />
              Days
            </th>
            <th>
              21
              <br />
              Days
            </th>
            <th>
              30
              <br />
              Days
            </th>
            <th>
              60+
              <br />
              Days
            </th>
          </tr>
        </thead>
        <tbody>
          {!data.length || isLoading ? (
            <tr>
              <td colSpan={13} className="text-center">
                <Loading
                  loading={isLoading}
                  errorText={isLoading ? "" : "No data available"}
                />
              </td>
            </tr>
          ) : (
            data.map((val, index) => {
              // Vars
              const payable_age = val.payable_age

              return (
                <tr>
                  <td>{index + 1}</td>
                  <td>
                    <PermissionLink
                      permission={PERMISION.PURCHASES.REGISTER.AGED_PAYABLE.UPDATE}
                      to={
                        val.jenis_bill === 3
                          ? `/purchase/transaction/bill-service/${val.bill_id}`
                          : val.jenis_bill === 2
                          ? `/purchase/transaction/direct-bill/edit/${val.bill_id}`
                          : `/purchase/transaction/enter-bills/${val?.purchase_order_id}/edit/${val.bill_id}`
                      }
                      target="_blank"
                      rel="noreferrer">
                      <IoSendSharp />
                    </PermissionLink>
                  </td>
                  <td>{val?.trx_code ?? "-"}</td>
                  <td>{val?.trx_code_po ?? "-"}</td>
                  <td>
                    {val?.transaction_date
                      ? convertDate(val?.transaction_date)
                      : "-"}
                  </td>
                  <td>{val?.vendor_name ?? "-"}</td>
                  <td className="text-right">
                    {val?.total_amount
                      ? convertNumber(val?.total_amount)?.intoCurrency
                      : "0"}
                  </td>
                  <td className="text-right">
                    {payable_age <= 7
                      ? convertNumber(val?.balance)?.intoCurrency
                      : "-"}
                  </td>
                  <td className="text-right">
                    {payable_age >= 8 && payable_age <= 15
                      ? convertNumber(val?.balance)?.intoCurrency
                      : "-"}
                  </td>
                  <td className="text-right">
                    {payable_age >= 16 && payable_age <= 21
                      ? convertNumber(val?.balance)?.intoCurrency
                      : "-"}
                  </td>
                  <td className="text-right">
                    {payable_age >= 22 && payable_age <= 30
                      ? convertNumber(val?.balance)?.intoCurrency
                      : "-"}
                  </td>
                  <td className="text-right">
                    {payable_age >= 31
                      ? convertNumber(val?.balance)?.intoCurrency
                      : "-"}
                  </td>
                </tr>
              )
            })
          )}
        </tbody>
      </BaseTable>
    </div>
  )
}
